import { createContext, useContext } from "react";

/* Models */
import yaris from "../assets/molelos/yaris.webp";
import yaris100 from "../assets/molelos/yaris100.webp";
import corolla from "../assets/molelos/corolla.webp";
import corollacross from "../assets/molelos/corollacross.webp";
import corollacrosshibrido from "../assets/molelos/corollahybrid.webp";
import hilux4x2 from "../assets/molelos/hilux4x2.webp";
import hilux4x4 from "../assets/molelos/hilux4x4.webp";
import hiace from "../assets/molelos/hiace.webp";
import yariscross from "../assets/molelos/yaris-cross.webp";

export const ConsContext = createContext();

export const useCons = () => {
  const context = useContext(ConsContext);
  if (!context) throw new Error("useCons must be used within a ConsContext");
  return context;
};

export const ConsContextProvider = ({ children }) => {
  const prices = {
    yariscross: {
      cuota: "473.340",
      valor: "41.464.000"
    },
    yaris70: {
      cuota: "372.009",
      valor: "34.284.000"
    },
    corolla: {
      cuota: "503.067",
      valor: "44.082.000"
    },
    corollacrosshibrido: {
      cuota: "746.684",
      valor: "55.063.000"
    },
    corollacross: {
      cuota: "592.939",
      valor: "51.918.000"
    },
    hilux4x2: {
      cuota: "535.215",
      valor: "49.325.000"
    },
    hilux4x4: {
      cuota: "847.779",
      valor: "59.383.000"
    },
    hiace: {
      cuota: "969.657",
      valor: "67.920.000"
    }
  };
  const modelos = [
    {
      key: "yariscross",
      id: 264,
      nombre: "Yaris Cross",
      modelo: "Toyota Yaris Cross",
      cuota: prices.yariscross.cuota,
      text1: `Valor de la unidad $${prices.yariscross.valor}`,
      text2: "Plan 70/30",
      text3: "Hasta en 84 Meses",
      text4: "Podés cancelar y adelantar cuotas",
      img: yariscross,
      dataButton: "Plan Toyota Yaris Cross"
    },
    {
      key: "yaris70",
      id: 227,
      nombre: "Yaris 70%",
      modelo: "Toyota Yaris 70%",
      cuota: prices.yaris70.cuota,
      plan: `Financiá hasta el 70%`,
      text1: `Valor de la unidad $${prices.yaris70.valor}`,
      text2: "Plan 70/30",
      text3: "Hasta en 84 Meses",
      text4: "Podés cancelar y adelantar cuotas",
      img: yaris,
      dataButton: "Plan Toyota Yaris 70%"
    },
    {
      key: "corolla",
      id: 2,
      nombre: "Corolla Sedan",
      modelo: "Toyota Corolla Sedan",
      cuota: prices.corolla.cuota,
      plan: `Financiá el 70%`,
      text1: `Valor de la unidad $${prices.corolla.valor}`,
      text2: "Plan 70/30",
      text3: "Hasta en 84 Meses",
      text4: "Podés cancelar y adelantar cuotas",
      img: corolla,
      dataButton: "Plan Toyota Corolla Sedan"
    }, {
      key: "corollacross-xli",
      id: 245,
      nombre: "Corolla Cross XLI",
      modelo: "Toyota Corolla Cross XLI",
      cuota: prices.corollacross.cuota,
      plan: `Financiá el 70%`,
      text1: `Valor de la unidad $${prices.corollacross.valor}`,
      text2: "Plan 70/30",
      text3: "Hasta en 84 Meses",
      text4: "Podés cancelar y adelantar cuotas",
      img: corollacross,
      dataButton: "Plan Toyota Corolla Cross XLI"
    },
   /*  {
      key: "corollacross-hibrido",
      id: 245,
      nombre: "Corolla Cross Híbrido",
      modelo: "Toyota Corolla Cross Híbrido",
      cuota: prices.corollacrosshibrido.cuota,
      plan: `Financiá el 100%`,
      text1: `Valor de la unidad $${prices.corollacrosshibrido.valor}`,
      text2: "Plan 100%",
      text3: "Hasta en 96 Meses",
      text4: "Podés cancelar y adelantar cuotas",
      img: corollacrosshibrido,
      dataButton: "Plan Toyota Corolla Cross Híbrido"
    }, */ {
      key: "hilux4x2",
      id: 1,
      nombre: "Hilux 4X2",
      modelo: "Toyota Hilux 4X2",
      cuota: prices.hilux4x2.cuota,
      plan: `Financiá el 70%`,
      text1: `Valor de la unidad $${prices.hilux4x2.valor}`,
      text2: "Plan 70/30",
      text3: "Hasta en 84 Meses",
      text4: "Podés cancelar y adelantar cuotas",
      img: hilux4x2,
      dataButton: "Plan Toyota Hilux 4X2"
    },
    {
      key: "hilux4x4",
      id: 1,
      nombre: "Hilux 4X4",
      modelo: "Toyota Hilux 4X4",
      cuota: prices.hilux4x4.cuota,
      plan: `Financiá el 100%`,
      text1: `Valor de la unidad $${prices.hilux4x4.valor}`,
      text2: "Plan 100%",
      text3: "Hasta en 96 Meses",
      text4: "Podés cancelar y adelantar cuotas",
      img: hilux4x4,
      dataButton: "Plan Toyota Hilux 4X4"
    },
    {
      id: 224,
      key: "hiace",
      nombre: "Hiace",
      modelo: "Toyota Hiace",
      cuota: prices.hiace.cuota,
      plan: `Financiá el 70%`,
      text1: `Valor de la unidad $${prices.hiace.valor}`,
      text2: "Plan 70/30",
      text3: "Hasta en 84 Meses",
      text4: "Podés cancelar y adelantar cuotas",
      img: hiace,
      dataButton: "Plan Toyota Hiace"
    }
  ];

  const themeOptions = {
    acentcolor: "#eb0a1e",
    dealer: "Zento",
    carBrand: "Toyota",
    brand: "logo.png",
    logo: "logoCons.png",
    urlHook: "https://hook.us1.make.com/y35h9gbfufxr4fniuicfz5a44v2giwxe"
  };

  const modelsOptions = modelos.map((model) => {
    return {
      value: model.dataButton,
      text: `${model.dataButton} (Cuota $${model.cuota})`,
      disabled: model.disabled
    };
  });

  console.log(modelsOptions);

  return (
    <ConsContext.Provider
      value={{
        prices,
        modelos,
        modelsOptions,
        themeOptions
      }}
    >
      {children}
    </ConsContext.Provider>
  );
};
